import React, { FunctionComponent, useMemo } from 'react';
import styled from 'styled-components';
import cn from 'classnames';
import { LoaderProps } from './types';
import BASE_64 from './Base64';

type StyledLoaderProps = {
  color: string;
};

const StyledLoader = styled.div<StyledLoaderProps>`
  background-size: contain;
  background-position: center;
  background-image: url(${({ color }) => BASE_64[color]});
`;

const Loader: FunctionComponent<LoaderProps> = ({
  white,
  size = 48,
  className = '',
  ...other
}) => {
  const sizeClasses = useMemo(() => {
    if (typeof size === 'number') {
      return cn(`w-${size}`, `h-${size}`);
    }
    let classes = cn(`w-${size.xs}`, `h-${size.xs}`);
    let prevSize = size.xs;

    if (size.sm && size.sm !== prevSize) {
      classes = cn(classes, `sm:w-${size.sm}`, `sm:h-${size.sm}`);
      prevSize = size.sm;
    }
    if (size.md && size.md !== prevSize) {
      classes = cn(classes, `md:w-${size.md}`, `md:h-${size.md}`);
      prevSize = size.md;
    }
    if (size.lg && size.lg !== prevSize) {
      classes = cn(classes, `lg:w-${size.lg}`, `lg:h-${size.lg}`);
    }
    return classes;
  }, [size]);

  return (
    <StyledLoader
      className={cn('flex-shrink-0', sizeClasses, className)}
      color={white ? 'white' : 'default'}
      {...other}
    />
  );
};

export default Loader;
